import { Component, EventEmitter, OnInit, Input, Output, ViewChild, ElementRef } from '@angular/core';
import { Router }            from '@angular/router';
import {Message, OverlayPanel, SelectItem, ConfirmDialog, ConfirmationService, SplitButton, MenuItem} from 'primeng/primeng';
import {UIChart} from 'primeng/primeng';

import * as ent from '../../entities/index'
import * as filters from '../../filters/index'
import * as enums from '../../enums/index'
import * as serv from '../../services/index'

//constants
import { Constants }         from '../../constants/Constants';

//components
import {MessageHandlerComponent} from '../Controls/MessageHandler.component';
import {BlockComponent} from '../Controls/Block.component';
import {SalesOfficeEditComponent} from '../../components/Editors/SalesOfficeEdit.component';


@Component({
  selector: 'my-salesoffice-grid',
  templateUrl: './SalesOfficeGrid.component.html'
})
export class SalesOfficeGridComponent implements OnInit {

    userInfo: ent.UserInfo;
    @ViewChild(MessageHandlerComponent) messageHandlerComponent: MessageHandlerComponent;
    @ViewChild(BlockComponent) blockComponent: BlockComponent;
    @ViewChild(SalesOfficeEditComponent) recordEditComponent: SalesOfficeEditComponent;

    records: ent.SalesOffice[];
    editedRecord: ent.SalesOffice;
    cols: any[];

    constructor(private configService: serv.ConfigService, private authenticationService: serv.AuthenticationService, 
        private router: Router, private domainDataService: serv.DomainDataService) 
    { 
      

    }

    ngOnInit(): void {

        if (!this.authenticationService.checkLoginStatus())
        {
            this.router.navigate(['login']);
        }
        this.userInfo = this.authenticationService.getUserInfo();
        this.recordEditComponent.salesOfficeTypeDropdownComponent.load();
        this.recordEditComponent.salesOfficeDropdownComponent.load();
        this.recordEditComponent.stateDropdownComponent.load();
        this.editedRecord = new ent.SalesOffice();
        this.loadColumns();
        this.onSearchClick(null);
    }

    loadColumns(){
        //Note: this is only needed for the p-table exportCSV function to work. Without loading the columns, that will throw an error.
        this.cols = [
            { field: 'ID', header: 'ID' },
            { field: 'SalesOfficeType.Name', header: 'Type' },
            { field: 'Name', header: 'Name' },
            { field: 'Number', header: 'Number' },
            { field: 'SalesOrg', header: 'Sales Org' },
            { field: 'CrossDockSalesOffice.Name', header: 'Cross Dock Name' },
            { field: 'CrossDockSalesOffice.Number', header: 'Cross Dock Number' },
            { field: 'AML', header: 'AML' },
            { field: 'FountainPlanningPlant', header: 'Fountain Planning Plant' },
            { field: 'CoolerAndVendorPlanningPlant', header: 'Cooler And Vendor Planning Plant' },
            { field: 'CalendarCode', header: 'Calendar Code' },
            { field: 'Inactive', header: 'Inactive' },
            { field: 'EnhancedPaymentOptions', header: 'Enhanced Payment Options' },
            { field: 'OffDayDeliveryFee', header: 'Off-Day Delivery Fee' },
            { field: 'CrossDockOverride', header: 'Cross Dock Override' },
            { field: 'StreetNumber', header: 'Street Number' },
            { field: 'StreetName', header: 'Street Name' },
            { field: 'City', header: 'City' },
            { field: 'State.Code', header: 'State' },
            { field: 'PostalCode', header: 'PostalCode' },
            { field: 'Latitude', header: 'Latitude' },
            { field: 'Longitude', header: 'Longitude' },
            { field: 'TaxCode', header: 'Tax Code' },
            { field: 'MapRefID', header: 'Map Ref ID' },
            { field: 'County', header: 'County' },
        ];

    }

    onAddClick(event: any){
        this.editedRecord = new ent.SalesOffice();
        //this.recordEditComponent.subtradeChannelDropdownComponent.value = null;
        this.recordEditComponent.displayDialog = true;
    }
    
    onEditClick(event: any, record: ent.SalesOffice){
        this.editedRecord = record;
        this.recordEditComponent.salesOfficeTypeDropdownComponent.value = record.SalesOfficeTypeID;
        this.recordEditComponent.salesOfficeDropdownComponent.value = record.CrossDockSalesOfficeID;
        this.recordEditComponent.stateDropdownComponent.value = record.StateID;
        this.recordEditComponent.displayDialog = true;
    }

    onRecordEditOK(){
        var request: ent.SaveSalesOfficeRequest = {SalesOffice: this.editedRecord, SavedByEmployee: this.userInfo.Employee};
        this.domainDataService.saveSalesOffice(request).subscribe(x=>{
            this.messageHandlerComponent.handleResponse(x);
            this.onSearchClick(null);
        });
    }

    public onSearchClick(event: any){
        this.blockComponent.blocked = true;
        var filter: filters.SalesOfficeFilter = {IncludeInactive: true};
        this.domainDataService.getSalesOffices(filter).subscribe(x=> {
            this.records = x;
            this.blockComponent.blocked = false;
        });
    }
}